// Website → server/index.mjs. Every call degrades gracefully: when there is no server
// (dist-single opened from disk, static hosting) it returns { offline: true }.
export type ApiResult<T> = { ok: true; data: T } | { ok: false; offline: boolean; error: string };

export async function api<T>(method: 'GET' | 'POST', url: string, body?: unknown): Promise<ApiResult<T>> {
  if (location.protocol === 'file:') return { ok: false, offline: true, error: 'offline' };
  try {
    const r = await fetch(url, {
      method,
      headers: body === undefined ? undefined : { 'Content-Type': 'application/json' },
      body: body === undefined ? undefined : JSON.stringify(body),
    });
    const isJson = (r.headers.get('content-type') || '').includes('application/json');
    if (!isJson) return { ok: false, offline: true, error: 'offline' }; // static host without the API
    const data = await r.json();
    if (!r.ok) return { ok: false, offline: false, error: data.error || 'เกิดข้อผิดพลาด' };
    return { ok: true, data: data as T };
  } catch {
    return { ok: false, offline: true, error: 'offline' };
  }
}
